import { useCallback } from "react";
import {
    checkObjectExists as checkObjectExistsInStorage,
    type ObjectExistenceStatus,
} from "@/integrations/storage/storageService";

/**
 * Прикладной слой над проверкой наличия объекта в Storage.
 *
 * Существует ради границы слоёв: страница вызывает сценарий, а не сервис
 * `integrations` напрямую. Логики здесь нет — только стабильная ссылка на
 * callback, чтобы хук можно было держать в зависимостях эффектов.
 */
export function useStorageObjectCheck() {
    const checkObjectExists = useCallback(
        (
            bucket: string,
            key: string,
            options?: { signal?: AbortSignal }
        ): Promise<ObjectExistenceStatus> => checkObjectExistsInStorage(bucket, key, options),
        []
    );

    return { checkObjectExists };
}
